export const SET_TEMPO = "SET_TEMPO";
export const SET_PLAY = "SET_PLAY";
export const SET_SUBDIVISION = "SET_SUBDIVISION";
export const SET_MUTE = "SET_MUTE";